import { render, staticRenderFns } from "./ReportRealTime.vue?vue&type=template&id=56ea0167&scoped=true"
import script from "./ReportRealTime.vue?vue&type=script&lang=js"
export * from "./ReportRealTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ea0167",
  null
  
)

export default component.exports